import React, {Component} from 'react';
import * as firebase from 'firebase';
import {Link} from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import Charts2 from '../component/charts2';
import Charts3 from '../component/charts3';
import GetBootstrapTable from '../component/getBootstrapTable';
import '../css/bootstrapTable.css'
export default class DetectionRecord extends Component {
  constructor(props){
    super(props);
    this.state = {
      totalAns: '',
      cm1ans: false,
      cm2ans: false,
      cm3ans: false,
      cm4ans: false,
      cm5ans: false,
      cm6ans: false,
      cm7ans: false,
      cm8ans: false,
      cm9ans: false
    }
    this.trClassFormat = this.trClassFormat.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0,0)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        var userId = firebase.auth().currentUser.uid;
        const quizRef = firebase.database().ref('users/').child(userId).child('Answers');
        const getNameRef = firebase.database().ref('users/').child(userId).child('UserProfile');
        getNameRef.on('value', snap => {
          this.setState({
            displayName: snap.val().displayName
          })
        })
        quizRef.on('value', snap => {
          var exists = (snap.val() !== null)
          if(exists) {

            var userId = firebase.auth().currentUser.uid
            const cmchart1Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('平和質(A型)');
            const cmchart2Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('氣虛質(B型)');
            const cmchart3Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('陽虛質(C型)');
            const cmchart4Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('陰虛質(D型)');
            const cmchart5Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('痰濕質(E型)');
            const cmchart6Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('濕熱質(F型)');
            const cmchart7Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('血瘀質(G型)');
            const cmchart8Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('氣鬱質(H型)');
            const cmchart9Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('特稟質(I型)');


            cmchart1Ref.on('child_added', snap => {
              this.setState({
                cm1ans: snap.val().ans
              })
            })
            cmchart2Ref.on('child_added', snap => {
              this.setState({
                cm2ans: snap.val().ans
              })
            })
            cmchart3Ref.on('child_added', snap => {
              this.setState({
                cm3ans: snap.val().ans
              })
            })
            cmchart4Ref.on('child_added', snap => {
              this.setState({
                cm4ans: snap.val().ans
              })
            })
            cmchart5Ref.on('child_added', snap => {
              this.setState({
                cm5ans: snap.val().ans
              })
            })
            cmchart6Ref.on('child_added', snap => {
              this.setState({
                cm6ans: snap.val().ans
              })
            })
            cmchart7Ref.on('child_added', snap => {
              this.setState({
                cm7ans: snap.val().ans
              })
            })
            cmchart8Ref.on('child_added', snap => {
              this.setState({
                cm8ans: snap.val().ans
              })
            })
            cmchart9Ref.on('child_added', snap => {
              this.setState({
                cm9ans: snap.val().ans
              })
            })

            if(this.state.cm1ans > 60) {
              this.setState({
                isT1: '您的身體目前檢測為平和質'
              })
            } else {
              this.setState({
                isT1: '不屬於平和質, 請完成中醫九大量表 才能更精準的幫您判斷喔'
              })
            }


            if(this.state.cm2ans > 40) {
              this.setState({
                isT2: '氣虛質(B型)',
                isT1: false,
                trendT2: false
              })
              const checkRef2 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('氣虛質')
              checkRef2.on('child_added', snap => {
                this.setState({
                  createDate2: snap.val().createDate,
                  createTime2: snap.val().createTime,
                  blogName2: snap.val().blogName,
                  blogTag2: snap.val().blogTag,
                  secondTag2: snap.val().secondTag,
                  listPhoto2: snap.val().listPhoto,
                  id2: snap.val().id,
                  author2: snap.val().author,
                  authorUrl2: snap.val().authorUrl,
                  theAuthor: 'https://herbalcure.com.tw/MedicalTeams/' + snap.val().userId,
                  name: snap.val().name
                 })
            })
            } else if (this.state.cm2ans > 30) {
              this.setState({
                trendT2: '氣虛質(B型)'
              })
            };

            if(this.state.cm3ans > 40) {
              this.setState({
                isT3: '陽虛質(C型)',
                isT1: false,
                trendT3: false
              })
              const checkRef3 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('陽虛質')
              checkRef3.on('child_added', snap => {
                this.setState({
                  createDate3: snap.val().createDate,
                  createTime3: snap.val().createTime,
                  blogName3: snap.val().blogName,
                  blogTag3: snap.val().blogTag,
                  secondTag3: snap.val().secondTag,
                  listPhoto3: snap.val().listPhoto,
                  id3: snap.val().id,
                  author3: snap.val().author,
                  authorUrl3: snap.val().authorUrl,
                  theAuthor: 'https://herbalcure.com.tw/MedicalTeams/' + snap.val().userId,
                  name: snap.val().name
                 })
            })
            } else if (this.state.cm3ans > 30) {
              this.setState({
                trendT3: '陽虛質(C型)'
              })
            };

            if(this.state.cm4ans > 40) {
              this.setState({
                isT4: '陰虛質(D型)',
                isT1: false,
                trendT4: false
              })
              const checkRef4 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('陰虛質')
              checkRef4.on('child_added', snap => {
                this.setState({
                  createDate4: snap.val().createDate,
                  createTime4: snap.val().createTime,
                  blogName4: snap.val().blogName,
                  blogTag4: snap.val().blogTag,
                  secondTag4: snap.val().secondTag,
                  listPhoto4: snap.val().listPhoto,
                  id4: snap.val().id,
                  author4: snap.val().author,
                  authorUrl4: snap.val().authorUrl,
                  theAuthor: 'https://herbalcure.com.tw/MedicalTeams/' + snap.val().userId,
                  name: snap.val().name
                 })
            })
            } else if (this.state.cm4ans > 30) {
              this.setState({
                trendT4: '陰虛質(D型)'
              })
            };

            if(this.state.cm5ans > 40) {
              this.setState({
                isT5: '痰濕質(E型)',
                isT1: false,
                trendT5: false
              })

              const checkRef5 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('痰濕質')
              checkRef5.on('child_added', snap => {
                this.setState({
                  createDate5: snap.val().createDate,
                  createTime5: snap.val().createTime,
                  blogName5: snap.val().blogName,
                  blogTag5: snap.val().blogTag,
                  secondTag5: snap.val().secondTag,
                  listPhoto5: snap.val().listPhoto,
                  id5: snap.val().id,
                  author5: snap.val().author,
                  authorUrl5: snap.val().authorUrl,
                  theAuthor: 'https://herbalcure.com.tw/MedicalTeams/' + snap.val().userId,
                  name: snap.val().name
                 })
            })

            } else if (this.state.cm5ans > 30) {
              this.setState({
                trendT5: '痰濕質(E型)'
              })
            };

            if(this.state.cm6ans > 40) {
              this.setState({
                isT6: '濕熱質(F型)',
                isT1: false,
                trendT6: false
              })
              const checkRef6 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('濕熱質')
              checkRef6.on('child_added', snap => {
                this.setState({
                  createDate6: snap.val().createDate,
                  createTime6: snap.val().createTime,
                  blogName6: snap.val().blogName,
                  blogTag6: snap.val().blogTag,
                  secondTag6: snap.val().secondTag,
                  listPhoto6: snap.val().listPhoto,
                  id6: snap.val().id,
                  author6: snap.val().author,
                  authorUrl6: snap.val().authorUrl,
                  theAuthor: 'https://herbalcure.com.tw/MedicalTeams/' + snap.val().userId,
                  name: snap.val().name
                 })
            })
            } else if (this.state.cm6ans > 30) {
              this.setState({
                trendT6: '濕熱質(F型)'
              })
            };

            if(this.state.cm7ans > 40) {
              this.setState({
                isT7: '血瘀質(G型)',
                isT1: false,
                trendT7: false
              })
              const checkRef7 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('血瘀質')
              checkRef7.on('child_added', snap => {
                this.setState({
                  createDate7: snap.val().createDate,
                  createTime7: snap.val().createTime,
                  blogName7: snap.val().blogName,
                  blogTag7: snap.val().blogTag,
                  secondTag7: snap.val().secondTag,
                  listPhoto7: snap.val().listPhoto,
                  id7: snap.val().id,
                  author7: snap.val().author,
                  authorUrl7: snap.val().authorUrl,
                  theAuthor: 'https://herbalcure.com.tw/MedicalTeams/' + snap.val().userId,
                  name: snap.val().name
                 })
            })
            } else if (this.state.cm7ans > 30) {
              this.setState({
                trendT7: '血瘀質(G型)'
              })
            };

            if(this.state.cm8ans > 40) {
              this.setState({
                isT8: '氣鬱質(H型)',
                isT1: false,
                trendT8: false
              })
              const checkRef8 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('氣鬱質')
              checkRef8.on('child_added', snap => {
                this.setState({
                  createDate8: snap.val().createDate,
                  createTime8: snap.val().createTime,
                  blogName8: snap.val().blogName,
                  blogTag8: snap.val().blogTag,
                  secondTag8: snap.val().secondTag,
                  listPhoto8: snap.val().listPhoto,
                  id8: snap.val().id,
                  author8: snap.val().author,
                  authorUrl8: snap.val().authorUrl,
                  theAuthor: 'https://herbalcure.com.tw/MedicalTeams/' + snap.val().userId,
                  name: snap.val().name
                 })
            })
            } else if (this.state.cm8ans > 30) {
              this.setState({
                trendT8: '氣鬱質(H型)'
              })
            };

            if(this.state.cm9ans > 40) {
              this.setState({
                isT9: '特稟質(I型)',
                isT1: false,
                trendT9: false
              })
              const checkRef9 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('特稟質')
              checkRef9.on('child_added', snap => {
                this.setState({
                  createDate9: snap.val().createDate,
                  createTime9: snap.val().createTime,
                  blogName9: snap.val().blogName,
                  blogTag9: snap.val().blogTag,
                  secondTag9: snap.val().secondTag,
                  listPhoto9: snap.val().listPhoto,
                  id9: snap.val().id,
                  author9: snap.val().author,
                  authorUrl9: snap.val().authorUrl,
                  theAuthor: 'https://herbalcure.com.tw/MedicalTeams/' + snap.val().userId,
                  name: snap.val().name
                 })
            })
            } else if (this.state.cm9ans > 30) {
              this.setState({
                trendT9: '特稟質(I型)'
              })
            };



          } else {
            console.log('沒有輸入')
          }
        })


      } else {
        window.location = ('/')
      }
    })
  }
  trClassFormat(row, rowIndex) {
    return rowIndex % 2 === 0 ? "tr-odd" : "tr-even";
  }


  render() {

    const isT1 = this.state.isT1
     ? <span>{this.state.isT1}</span>
     : null
    const isT2 = this.state.isT2
     ? <span>{this.state.isT2}</span>
     : null
    const isT3 = this.state.isT3
     ? <span>{this.state.isT3}</span>
     : null
    const isT4 = this.state.isT4
     ? <span>{this.state.isT4}</span>
     : null
    const isT5 = this.state.isT5
     ? <span>{this.state.isT5}</span>
     : null
    const isT6 = this.state.isT6
     ? <span>{this.state.isT6}</span>
     : null
    const isT7 = this.state.isT7
     ? <span>{this.state.isT7}</span>
     : null
    const isT8 = this.state.isT8
     ? <span>{this.state.isT8}</span>
     : null
    const isT9 = this.state.isT9
     ? <span>{this.state.isT9}</span>
     : null
    const trendT2 = this.state.trendT2
     ? <span>{this.state.trendT2}</span>
     : null
    const trendT3 = this.state.trendT3
     ? <span>{this.state.trendT3}</span>
     : null
   const trendT4 = this.state.trendT4
     ? <span>{this.state.trendT4}</span>
     : null
   const trendT5 = this.state.trendT5
     ? <span>{this.state.trendT5}</span>
     : null
   const trendT6 = this.state.trendT6
     ? <span>{this.state.trendT6}</span>
     : null
   const trendT7 = this.state.trendT7
     ? <span>{this.state.trendT7}</span>
     : null
   const trendT8 = this.state.trendT8
     ? <span>{this.state.trendT8}</span>
     : null
   const trendT9 = this.state.trendT9
     ? <span>{this.state.trendT9}</span>
     : null
   const youre = this.state.isT1 || this.state.isT2 || this.state.isT3 || this.state.isT4 || this.state.isT5 || this.state.isT6 || this.state.isT7 || this.state.isT1 || this.state.isT9
     ? <div className="your"><strong>您的中醫體質:</strong><br /> {isT1}{isT2}{isT3}{isT4}{isT5}{isT6}{isT7}{isT8}{isT9}</div>
     : null
   const youreTrend = this.state.trendT2 || this.state.trendT3 || this.state.trendT4 || this.state.trendT5 || this.state.trendT6 || this.state.trendT7 || this.state.trendT8 || this.state.trendT9
     ? <div className="youreTrend"><strong>傾向於:</strong> {trendT2}{trendT3}{trendT4}{trendT5}{trendT6}{trendT7}{trendT8}{trendT9}</div>
     : null
   const Article2 = this.state.id2
     ? <article key={this.state.id2} className="postBox">
                 <sub><span>{this.state.createDate2}</span> <span>{this.state.createTime2}</span></sub>
                 <Link to={"/AuthorityBlogs/" + this.state.id2}>
                  <h1>{ this.state.blogName2 }</h1>
                  <div className="postListBox">
                   <img
                     src={this.state.listPhoto2}
                     alt={this.state.blogTag2}
                   />
                  </div>
                 </Link>
                 <sub className="postListTagsBox">
                  <Link to={"/AuthorityTag/" + this.state.blogTag2}>{ this.state.blogTag2 }</Link>
                  <Link to={"/AuthorityTags/" + this.state.secondTag2}>{ this.state.secondTag2 }</Link>
                  <a href={this.state.theAuthor} target="_blank" rel="noopener noreferrer" className="author" style={{display:'block', margin: '5px 0 -2px 0'}}>發文者: {this.state.name}</a>
                  <a href={this.state.authorUrl2} target="_blank" rel="noopener noreferrer" className="author" style={{display: this.state.author2 ? 'block' : 'none'}} >引用自: {this.state.author2}</a>
                 </sub>
               </article>
     : null
   const Article3 = this.state.id3
     ? <article key={this.state.id3} className="postBox">
                 <sub><span>{this.state.createDate3}</span> <span>{this.state.createTime3}</span></sub>
                 <Link to={"/AuthorityBlogs/" + this.state.id3}>
                  <h1>{ this.state.blogName3 }</h1>
                  <div className="postListBox">
                   <img
                     src={this.state.listPhoto3}
                     alt={this.state.blogTag3}
                   />
                  </div>
                 </Link>
                 <sub className="postListTagsBox">
                  <Link to={"/AuthorityTag/" + this.state.blogTag3}>{ this.state.blogTag3 }</Link>
                  <Link to={"/AuthorityTags/" + this.state.secondTag3}>{ this.state.secondTag3 }</Link>
                  <a href={this.state.theAuthor} target="_blank" rel="noopener noreferrer" className="author" style={{display:'block', margin: '5px 0 -2px 0'}}>發文者: {this.state.name}</a>
                  <a href={this.state.authorUrl3} target="_blank" rel="noopener noreferrer" className="author" style={{display: this.state.author3 ? 'block' : 'none'}}>引用自: {this.state.author3}</a>
                 </sub>
               </article>
     : null
   const Article4 = this.state.id4
     ? <article key={this.state.id4} className="postBox">
                 <sub><span>{this.state.createDate4}</span> <span>{this.state.createTime4}</span></sub>
                 <Link to={"/AuthorityBlogs/" + this.state.id4}>
                  <h1>{ this.state.blogName4 }</h1>
                  <div className="postListBox">
                   <img
                     src={this.state.listPhoto4}
                     alt={this.state.blogTag4}
                   />
                  </div>
                 </Link>
                 <sub className="postListTagsBox">
                  <Link to={"/AuthorityTag/" + this.state.blogTag4}>{ this.state.blogTag4 }</Link>
                  <Link to={"/AuthorityTags/" + this.state.secondTag4}>{ this.state.secondTag4 }</Link>
                  <a href={this.state.theAuthor} target="_blank" rel="noopener noreferrer" className="author" style={{display:'block', margin: '5px 0 -2px 0'}}>發文者: {this.state.name}</a>
                  <a href={this.state.authorUrl4} target="_blank" rel="noopener noreferrer" className="author" style={{display: this.state.author4 ? 'block' : 'none'}}>引用自: {this.state.author4}</a>
                 </sub>
               </article>
     : null
   const Article5 = this.state.id5
     ? <article key={this.state.id5} className="postBox">
               <sub><span>{this.state.createDate5}</span> <span>{this.state.createTime5}</span></sub>
               <Link to={"/AuthorityBlogs/" + this.state.id5}>
                <h1>{ this.state.blogName5 }</h1>
                <div className="postListBox">
                 <img
                   src={this.state.listPhoto5}
                   alt={this.state.blogTag5}
                 />
                </div>
               </Link>
               <sub className="postListTagsBox">
                <Link to={"/AuthorityTag/" + this.state.blogTag5}>{ this.state.blogTag5 }</Link>
                <Link to={"/AuthorityTags/" + this.state.secondTag5}>{ this.state.secondTag5 }</Link>
                <a href={this.state.theAuthor} target="_blank" rel="noopener noreferrer" className="author" style={{display:'block', margin: '5px 0 -2px 0'}}>發文者: {this.state.name}</a>
                <a href={this.state.authorUrl5} target="_blank" rel="noopener noreferrer" className="author" style={{display: this.state.author5 ? 'block' : 'none'}}>引用自: {this.state.author5}</a>
               </sub>
             </article>
     : null
    const Article6 = this.state.id6
     ? <article key={this.state.id6} className="postBox">
                 <sub><span>{this.state.createDate6}</span> <span>{this.state.createTime6}</span></sub>
                 <Link to={"/AuthorityBlogs/" + this.state.id6}>
                  <h1>{ this.state.blogName6 }</h1>
                  <div className="postListBox">
                   <img
                     src={this.state.listPhoto6}
                     alt={this.state.blogTag6}
                   />
                  </div>
                 </Link>
                 <sub className="postListTagsBox">
                  <Link to={"/AuthorityTag/" + this.state.blogTag6}>{ this.state.blogTag6 }</Link>
                  <Link to={"/AuthorityTags/" + this.state.secondTag6}>{ this.state.secondTag6 }</Link>
                  <a href={this.state.theAuthor} target="_blank" rel="noopener noreferrer" className="author" style={{display:'block', margin: '5px 0 -2px 0'}}>發文者: {this.state.name}</a>
                  <a href={this.state.authorUrl6} target="_blank" rel="noopener noreferrer" className="author" style={{display: this.state.author6 ? 'block' : 'none'}}>引用自: {this.state.author6}</a>
                 </sub>
               </article>
     : null
   const Article7 = this.state.id7
     ? <article key={this.state.id7} className="postBox">
                 <sub><span>{this.state.createDate7}</span> <span>{this.state.createTime7}</span></sub>
                 <Link to={"/AuthorityBlogs/" + this.state.id7}>
                  <h1>{ this.state.blogName7 }</h1>
                  <div className="postListBox">
                   <img
                     src={this.state.listPhoto7}
                     alt={this.state.blogTag7}
                   />
                  </div>
                 </Link>
                 <sub className="postListTagsBox">
                  <Link to={"/AuthorityTag/" + this.state.blogTag7}>{ this.state.blogTag7 }</Link>
                  <Link to={"/AuthorityTags/" + this.state.secondTag7}>{ this.state.secondTag7 }</Link>
                  <a href={this.state.theAuthor} target="_blank" rel="noopener noreferrer" className="author" style={{display:'block', margin: '5px 0 -2px 0'}}>發文者: {this.state.name}</a>
                  <a href={this.state.authorUrl7} target="_blank" rel="noopener noreferrer" className="author" style={{display: this.state.author7 ? 'block' : 'none'}}>引用自: {this.state.author7}</a>
                 </sub>
               </article>
     : null
   const Article8 = this.state.id8
     ? <article key={this.state.id8} className="postBox">
                 <sub><span>{this.state.createDate8}</span> <span>{this.state.createTime8}</span></sub>
                 <Link to={"/AuthorityBlogs/" + this.state.id8}>
                  <h1>{ this.state.blogName8 }</h1>
                  <div className="postListBox">
                   <img
                     src={this.state.listPhoto8}
                     alt={this.state.blogTag8}
                   />
                  </div>
                 </Link>
                 <sub className="postListTagsBox">
                  <Link to={"/AuthorityTag/" + this.state.blogTag8}>{ this.state.blogTag8 }</Link>
                  <Link to={"/AuthorityTags/" + this.state.secondTag8}>{ this.state.secondTag8 }</Link>
                  <a href={this.state.theAuthor} target="_blank" rel="noopener noreferrer" className="author" style={{display:'block', margin: '5px 0 -2px 0'}}>發文者: {this.state.name}</a>
                  <a href={this.state.authorUrl8} target="_blank" rel="noopener noreferrer" className="author" style={{display: this.state.author8 ? 'block' : 'none'}}>引用自: {this.state.author8}</a>
                 </sub>
               </article>
     : null
   const Article9 = this.state.id9
     ? <article key={this.state.id9} className="postBox">
                 <sub><span>{this.state.createDate9}</span> <span>{this.state.createTime9}</span></sub>
                 <Link to={"/AuthorityBlogs/" + this.state.id9}>
                  <h1>{ this.state.blogName9 }</h1>
                  <div className="postListBox">
                   <img
                     src={this.state.listPhoto9}
                     alt={this.state.blogTag9}
                   />
                  </div>
                 </Link>
                 <sub className="postListTagsBox">
                  <Link to={"/AuthorityTag/" + this.state.blogTag9}>{ this.state.blogTag9 }</Link>
                  <Link to={"/AuthorityTags/" + this.state.secondTag9}>{ this.state.secondTag9 }</Link>
                  <a href={this.state.theAuthor} target="_blank" rel="noopener noreferrer" className="author" style={{display:'block', margin: '5px 0 -2px 0'}}>發文者: {this.state.name}</a>
                  <a href={this.state.authorUrl9} target="_blank" rel="noopener noreferrer" className="author" style={{display: this.state.author9 ? 'block' : 'none'}}>引用自: {this.state.author9}</a>
                 </sub>
               </article>
     : null
   const relatedArticles = this.state.id2 || this.state.id3 || this.state.id4 || this.state.id5 || this.state.id6 || this.state.id7 || this.state.id8 || this.state.id9
     ? <div>
        <p>適合您的文章</p>
        <div className="masonry">
        {Article2}{Article3}{Article4}{Article5}{Article6}{Article7}{Article8}{Article9}
        </div>
       </div>
     : null

    return(
      <div style={{overflowX: 'hidden'}}>
        <MetaTags>
            <title>草學藥事 || 體質分析檢測紀錄</title>
            <meta id="og-title" property="og:title" content="體質分析檢測紀錄" />
        </MetaTags>
       <div>
        <p style={{textAlign: 'center', margin: '20px auto'}}>Hi / {this.state.displayName}</p>
        <div style={{margin: '20px 0', fontSize: 20, color: '#325aaa'}}>
         <div>{youre}</div>
         <div>{youreTrend}</div>
        </div>
       </div>
       <Charts3 />
       <Charts2 />
       <div style={{margin: '100px 0', fontSize: 20, color: '#325aaa'}}>
        <div>{relatedArticles}</div>
       </div>
       <GetBootstrapTable />

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/DetectionRecord.js